<template>
  <div class="w-full h-full">
    <spinner-wheel-table :variant="variant" v-if="variant" />
  </div>
</template>

<script>
import SpinnerWheelTableContainer from '@/containers/spinner-wheel/spinnerWheelTable'

import SpinnerWheelTable from './SpinnerWheelTable.vue'

export default {
  components: {
    SpinnerWheelTable: SpinnerWheelTableContainer(SpinnerWheelTable),
  },
  data() {
    return {
      variant: 'white',
    }
  },
  watch: {
    '$store.state.slideActive.textColour': function () {
      this._getVariant()
    },
  },
  created() {
    this._getVariant()
  },
  methods: {
    _getVariant() {
      if (this.$store.state.slideActive.textColour === '#ffffff') {
        this.variant = 'dark'
      } else {
        this.variant = 'white'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
